module.exports = __webpack_public_path__ + "img/org09.268f17fd.png";